import '@/lib/sockjs'
import '@/lib/stomp'
import {archive_socket_url} from "@/api/uri/socket";
import SpeechSynthesis from '@/utils/speechSynthesis'
import voiceText from '@/config/voiceText'
import {timeStampToDate} from '@/utils/index'
import Toast from '@/utils/toast'

const speechSynthesis = new SpeechSynthesis();
const socketMsgType = {
  OUT_SIDE_ADD: 1,
  OUT_SIDE_UPDATE: 2,
  OUT_SIDE_DELETE: 3,
  OUT_SIDE_REFRESH: 4,
  COME_BACK_ADD: 5,
  COME_BACK_UPDATE: 6,
  COME_BACK_DELETE: 7,
  COME_BACK_REFRESH: 8,
  REFRESH_ALL: 9,
}

/**
 * 操作成功提示
 * @param type 1:请假 2:自由出行
 * @param isOutside 是否出行
 * @param data 数据
 * @param isRepeat 是否重复刷卡
 */
function _showTipBySuccess(type, isOutside, data, isRepeat) {
  //文字提示
  if (isOutside) {
    let tip = `长者姓名: ${data.oldpeopleName}`;
    if (type === 2 && data.liveInfo && data.liveInfo.bedRoute) {
      tip = tip + `  居住位置: ${data.liveInfo.bedRoute}`;
    }
    if (type === 1 && data.bed) {
      tip = tip + `  居住位置: ${data.bed}`;
    }
    if (type === 1) {
      if (data.guardian) {
        tip = tip + `  陪同人:${data.guardian}`;
        if (data.guardianPhone) {
          tip = tip + `  (${data.guardianPhone})`;
        }
      } else if (data.guardianPhone) {
        tip = tip + `  陪同人联系方式:${data.guardianPhone}`;
      } else {
        tip = '暂无陪同人';
      }
    }

    Toast.show({
      message: tip,
    })
  }

  //语音提示
  if (isOutside) {
    if (isRepeat) {
      speechSynthesis.play(voiceText.haveOutRecord);
    } else {
      speechSynthesis.play(voiceText.outRecordSwipeCardSuccess);
    }
  } else {
    if (type === 1) {
      if (isRepeat) {
        speechSynthesis.play(voiceText.haveOutRecord);
      } else {
        speechSynthesis.play(voiceText.oldPeopleComeBackByLeave + ' ' + data.oldpeopleName);
      }
    }
    if (type === 2) {
      speechSynthesis.play(voiceText.oldPeopleComeBackByFreedom);
    }
  }
}

export const outRecord = {
  namespaced: true,
  state: {
    stomp: null,
    timer: null,
    socketFlag: true,
    outRecordListByLeave: [],//请假出行
    comeBackListByLeave: [],//销假回来
    outRecordListByFreedom: [],//自由出行
    comeBackListByFreedom: [],//自由出行回来
  },
  getters: {
    //获取所有的出行记录
    //{imageUrl:头像, idcard:卡号, oldpeopleName:长者名,type:1请假2自由出行 , }
    getAllOutRecordList: state => {
      let list = [];
      (state.outRecordListByLeave || []).forEach(item => {
        list.push({
          imageUrl: item.imageUrl,
          idcard: item.idcard,
          oldpeopleName: item.oldpeopleName,
          livingNumber: item.oldPeople ? item.oldPeople.livingNumber : '',
          type: 1,
          oldPeople:item.oldPeople
        })
      });
      (state.outRecordListByFreedom || []).forEach(item => {
        list.push({
          imageUrl: item.imageUrl,
          idcard: item.idcard,
          oldpeopleName: item.oldpeopleName,
          livingNumber: item.oldPeople ? item.oldPeople.livingNumber : '',
          type: 2,
          oldPeople:item.oldPeople
        })
      });
      return list;
    },
    //获取所有的回来记录
    //{imageUrl:头像, idcard:卡号, oldpeopleName:长者名,type:1请假2自由出行  }
    getAllComeBackList: state => {
      let list = [];
      (state.comeBackListByLeave || []).forEach(item => {
        list.push({
          imageUrl: item.imageUrl,
          idcard: item.idcard,
          oldpeopleName: item.oldpeopleName,
          livingNumber: item.oldPeople ? item.oldPeople.livingNumber : '',
          type: 1,
          oldPeople:item.oldPeople
        })
      });
      (state.comeBackListByFreedom || []).forEach(item => {
        list.push({
          imageUrl: item.imageUrl,
          idcard: item.idcard,
          oldpeopleName: item.oldpeopleName,
          livingNumber: item.oldPeople ? item.oldPeople.livingNumber : '',
          type: 2,
          oldPeople:item.oldPeople
        })
      });
      return list;
    },
    /**
     * 查找是否存在今日出行列表中
     */
    findOutRecordByCardId: state => idcard => {
      let type = 1;
      let find = (state.outRecordListByLeave || []).find(item => {
        return item.idcard.toLowerCase() === idcard.toLowerCase();
      })
      if (!find) {
        find = (state.outRecordListByFreedom || []).find(item => {
          return item.idcard.toLowerCase() === idcard.toLowerCase();
        })
        type = 2;
      }
      if (!find) {
        type = null;
      }
      return {type: type, data: find};
    },


    /**
     *  查找是否存在今日归来列表中 优先取出请假记录
     */
    findComeBackByCardId: state => idcard => {
      let type = 2;
      let find = (state.comeBackListByFreedom || []).find(item => {
        return item.idcard.toLowerCase() === idcard.toLowerCase();
      })

      if (!find) {
        find = (state.comeBackListByLeave || []).find(item => {
          return item.idcard.toLowerCase() === idcard.toLowerCase();
        })
        type = 1;
      }
      if (!find) {
        type = null;
      }
      return {type: type, data: find};
    },
    //统计今天出行人数(无论销不销假)
    getTodayOutRecordNum: state => {
      let today = new Date();
      let num = state.outRecordListByLeave.length + state.outRecordListByFreedom.length;
      (state.comeBackListByLeave || []).forEach(item => {
        if (timeStampToDate(today, 'yyyy-mm-dd') === timeStampToDate(item.allowTime, 'yyyy-mm-dd')) {
          num++;
        }
      });
      (state.comeBackListByFreedom || []).forEach(item => {
        if (timeStampToDate(today, 'yyyy-mm-dd') === item.goOutsideDate) {
          num++;
        }
      });
      return num;
    },
    //统计今天归来人数(无论销不销假)
    getTodayComeBackNum: state => {
      let num = state.comeBackListByLeave.length + state.comeBackListByFreedom.length;
      return num;
    }
  },
  mutations: {
    setOutRecordListByLeave(state, outRecordListByLeave) {
      if (outRecordListByLeave === undefined || outRecordListByLeave === null) {
        state.outRecordListByLeave = [];
      } else {
        state.outRecordListByLeave = outRecordListByLeave;
      }
    },
    addOutRecordByLeave(state, outRecord) {
      let findIndex = state.outRecordListByLeave.findIndex(item => {
        return item.id === outRecord.id
      })
      if (findIndex === -1) {
        state.outRecordListByLeave.push(outRecord);
      } else {
        state.outRecordListByLeave.splice(findIndex, 1, outRecord)
      }

    },

    removeOutRecordByLeave(state, id) {
      let findIndex = state.outRecordListByLeave.findIndex(item => {
        return item.id === id
      })
      if (findIndex !== -1) {
        state.outRecordListByLeave.splice(findIndex, 1);
      }
    },

    removeOutRecordListByLeave(state) {
      state.outRecordListByLeave = [];

    },

    setComeBackListByLeave(state, comeBackListByLeave) {
      if (comeBackListByLeave === undefined || comeBackListByLeave === null) {
        state.comeBackListByLeave = [];
      } else {
        state.comeBackListByLeave = comeBackListByLeave;
      }
    },

    // 添加归来列表
    addComeBackByLeave(state, comeBack) {
      let findIndex = state.comeBackListByLeave.findIndex(item => {
        return item.id === comeBack.id
      })
      if (findIndex === -1) {
        state.comeBackListByLeave.push(comeBack);
        //销假成功
        _showTipBySuccess(1, false, comeBack, false);
      } else {
        state.comeBackListByLeave.splice(findIndex, 1, comeBack)
      }
    },
    removeComeBackByLeave(state, id) {
      let findIndex = state.comeBackListByLeave.findIndex(item => {
        return item.id === id
      })
      if (findIndex !== -1) {
        state.comeBackListByLeave.splice(findIndex, 1);
      }
    },
    removeComeBackListByLeave(state) {
      state.comeBackListByLeave = [];
    },

    //自由出行
    setOutRecordListByFreedom(state, outRecordListByFreedom) {
      if (outRecordListByFreedom === undefined || outRecordListByFreedom === null) {
        state.outRecordListByFreedom = [];
      } else {
        state.outRecordListByFreedom = outRecordListByFreedom;
      }
    },
    addOutRecordByFreedom(state, outRecord) {
      let findIndex = state.outRecordListByFreedom.findIndex(item => {
        return item.id === outRecord.id
      })
      if (findIndex === -1) {
        state.outRecordListByFreedom.push(outRecord);
        _showTipBySuccess(2, true, outRecord, false);
      } else {
        state.outRecordListByFreedom.splice(findIndex, 1, outRecord)
      }


    },
    removeOutRecordByFreedom(state, id) {
      let findIndex = state.outRecordListByFreedom.findIndex(item => {
        return item.id === id
      })
      if (findIndex !== -1) {
        state.outRecordListByFreedom.splice(findIndex, 1);
      }
    },
    removeOutRecordListByFreedom(state) {
      state.outRecordListByFreedom = [];

    },

    setComeBackListByFreedom(state, comeBackListByFreedom) {
      if (comeBackListByFreedom === undefined || comeBackListByFreedom === null) {
        state.comeBackListByFreedom = [];
      } else {
        state.comeBackListByFreedom = comeBackListByFreedom;
      }
    },

    addComeBackByFreedom(state, comeBack) {
      let findIndex = state.comeBackListByFreedom.findIndex(item => {
        return item.id === comeBack.id
      })
      if (findIndex === -1) {
        _showTipBySuccess(2, false, comeBack, false);
        state.comeBackListByFreedom.push(comeBack);
      } else {
        state.comeBackListByFreedom.splice(findIndex, 1, comeBack)
      }
    },
    removeComeBackByFreedom(state, id) {
      let findIndex = state.comeBackListByFreedom.findIndex(item => {
        return item.id === id
      })
      if (findIndex !== -1) {
        state.comeBackListByFreedom.splice(findIndex, 1);
      }
    },
    removeComeBackListByFreedom(state) {
      state.comeBackListByFreedom = [];

    },
  },
  actions: {
    //websocket订阅
    connect(context, str) {
      let headers = {}
      return new Promise((resolve, reject) => {

        let sockJs = new SockJS(archive_socket_url.webSocket,'',{
          timeout: 5000
        });

        //获取 STOMP 子协议的客户端对象
        context.state.stomp = Stomp.over(sockJs);

        //向服务器发起websocket连接并发送CONNECT帧
        context.state.stomp.connect(headers, frame => {
          console.log('outRecord链接我成功了吗？？？？？')

          // 关闭定时器
          clearInterval(context.state.timer);

          // 连接成功时（服务器响应 CONNECTED 帧）的回调方法
          //STOMP 客户端要想接收来自服务器推送的消息，必须先订阅相应的URL，即发送一个 SUBSCRIBE 帧，然后才能不断接收来自服务器的推送消息；
          //  var subscription = client.subscribe(...); 取消订阅subscription.unsubscribe();
          context.dispatch('socketSplit', {
            stomp: context.state.stomp,
            resolve: resolve
          });

          //关闭stomp日志
          context.state.stomp.debug = null;

        }, failedMsg => {
          console.log("outRecordwebsocket,链接失败")

          // todo 连接失败，轮询接口
          context.state.stomp.disconnect(() => {

            console.log("websocket,终止链接")

            sockJs.onclose = (e) => {
              sockJs.close();
              console.log('onclose,关闭请求',e)
            }
            // todo 链接失败，2秒重新连接
            console.log("????",context.state.timer);

            context.state.timer = setTimeout(()=> {
              context.dispatch("connect");
            },10000)

          })

        });
      });
    },
    // 订阅消息
    socketSplit(context, {resolve}) {
      console.log('outRecord接收订阅前')
      let headers = {};
      let stomp = context.state.stomp;
      if (stomp) {
        let messageFunction = function (message) {
          if (message.body) {
            let data = JSON.parse(message.body);
            console.info(data, message.headers.destination)
            let suffix = null;
            if (message.headers.destination === archive_socket_url.getListFreedomByToday) {
              suffix = 'ByFreedom';
            }
            if (message.headers.destination === archive_socket_url.getListLeaveByToday) {
              suffix = 'ByLeave';
            }
            if (data.status === 1) {
              //刷新全部
              if (data.msgType === socketMsgType.REFRESH_ALL) {
                context.commit(`setOutRecordList${suffix}`, data.data.noneComeBack);
                context.commit(`setComeBackList${suffix}`, data.data.comeBack);
              }

              if (data.msgType === socketMsgType.OUT_SIDE_REFRESH) {
                context.commit(`setOutRecordList${suffix}`, data.data);
              }
              if (data.msgType === socketMsgType.OUT_SIDE_ADD) {
                context.commit(`addOutRecord${suffix}`, data.data);
              }
              if (data.msgType === socketMsgType.OUT_SIDE_DELETE) {
                (data.data || []).forEach(id => {
                  context.commit(`removeOutRecord${suffix}`, id);
                })
              }
              if (data.msgType === socketMsgType.COME_BACK_REFRESH) {
                context.commit(`setComeBackList${suffix}`, data.data);
              }
              if (data.msgType === socketMsgType.COME_BACK_ADD) {
                context.commit(`addComeBack${suffix}`, data.data);
              }
              if (data.msgType === socketMsgType.COME_BACK_DELETE) {
                (data.data || []).forEach(id => {
                  context.commit(`removeComeBack${suffix}`, id);
                })
              }
            }
          }
          //通知服务器，已经收到消息
          message.ack();
          resolve(true)
        };
        stomp.subscribe(archive_socket_url.getListFreedomByToday, messageFunction, headers);

        stomp.subscribe(archive_socket_url.getListLeaveByToday, messageFunction, headers);

      }
    },
    // 关闭socket
    closeSocket(context) {
      console.log('outRecord关闭websocket')
      context.state.stomp.disconnect(function () {
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/outRecord.js